const toDate = (dateString)=>{
    if (Number.isNaN(Date.parse(dateString))) return '';
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
};
const toDateDeclensionMonth = (date)=>new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(date ? new Date(date) : new Date()).replace(' г. в', '');
export { toDate, toDateDeclensionMonth };
